import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'react-intl';
import { QRcode } from '../../../../component';
import './mobileTicket.scss';

const PassengerInfo = (props) => {
  const { name, direction } = props.language;
  const [passengers, setPassengers] = useState(props.currentFlight.passengers);
  const [lastPageX, setLastPageX] = useState(0);
  const [slideIndex, setSlideIndex] = useState(0);

  useEffect(() => {
    return () => {};
  }, []);
  //when touch element
  const onStartMoveElement = (e, index) => {
    e.stopPropagation();
    // if (index === 0)
    setLastPageX(e.pageX || e.targetTouches[0].pageX);
  };
  // drag element with touch
  const onMoveElement = (e, index) => {
    e.stopPropagation();
    // if (index === 0) {
    let offset =
      lastPageX === 0 ? 0 : (e.pageX || e.targetTouches[0].pageX) - lastPageX;

    move(offset);
    // }
  };

  // set element how much moved
  const move = (offset) => {
    cssAttribute('left', `${Math.round(offset)}px`);
  };

  // leve element
  const onDropElement = (e, index) => {
    e.stopPropagation();
    // if (index === 0) {
    let offset = getleftMargin();
    end(offset);
    // }
  };

  // set nimation after drop element
  const end = (offset) => {
    if (offset > CurrentElementWidth() / 4) setAnimation('goToRight');
    else if (offset < -(CurrentElementWidth() / 4)) setAnimation('goToLeft');
    else {
      addCssClass('transition');
      cssAttribute('left', `0px`);
      setTimeout(() => {
        removeCssClass('transition');
      }, 260);
    }
  };
  // set animatoin to element and after time out remove animation
  const setAnimation = (animation, index = undefined) => {
    addCssClass(animation);
    setTimeout(() => {
      cssAttribute('left', `0px`);
      removeCssClass(animation);
      if (index == undefined) {
        if (animation == 'goToLeft') {
          direction === 'rtl' ? turnLeftDot() : turnRightDot();
        } else {
          direction === 'rtl' ? turnRightDot() : turnLeftDot();
        }
      } else setSlideIndex(index);
    }, 260);
  };

  const turnLeftDot = () => {
    slideIndex === 0
      ? setSlideIndex(passengers.length - 1)
      : setSlideIndex(slideIndex - 1);
  };

  const turnRightDot = () => {
    slideIndex === passengers.length - 1
      ? setSlideIndex(0)
      : setSlideIndex(slideIndex + 1);
  };

  const addCssClass = (cssClass) => {
    document
      .getElementById(`item-passenger-${slideIndex}`)
      .classList.add(cssClass);
  };
  const removeCssClass = (cssClass) => {
    document
      .getElementById(`item-passenger-${slideIndex}`)
      .classList.remove(cssClass);
  };
  const CurrentElementWidth = () =>
    document.getElementById(`item-passenger-${slideIndex}`).offsetWidth;

  const cssAttribute = (key, value) =>
    (document.getElementById(`item-passenger-${slideIndex}`).style[key] =
      value);

  const getleftMargin = () => {
    const leftValue = window.getComputedStyle(
      document.getElementById(`item-passenger-${slideIndex}`),
    ).left;
    return parseInt(leftValue.replace('px', ''));
  };

  let { currentFlight, id } = props;
  let AgencyLogo = currentFlight?.onBehalfProfile?.basicInfo?.logo || '';
  const hostName = window.location.origin.includes('tripord')
    ? 'tripord.com'
    : 'tripsi.ir';
  return (
    <Fragment>
      <div className="d-flex flex-column w-100 h-100  overflow-hidden">
        <div className="d-flex position-relative w-100 h-100  d-flex justify-content-center align-items-center ">
          {passengers.map((item, index) => {
            if (index === 0) {
            }
            let currentTicket =
              (props.currentFlight.tickets &&
                props.currentFlight.tickets.length &&
                props.currentFlight.tickets.filter(
                  (t) =>
                    t.passengerIndex === index &&
                    t.flightIndex === props.currentFlightIndex,
                )[0]) ||
              null;
            return (
              <div
                id={`item-passenger-${index}`}
                key={`${index}-item-passenger`}
                className={`w-100   overflow-hidden justify-content-center align-items-center flex-column  ${
                  index === slideIndex ? 'active' : 'd-none'
                } `}
                onMouseEnter={(e) => {
                  onStartMoveElement(e, index);
                }}
                onMouseMove={(e) => {
                  onMoveElement(e, index);
                }}
                onMouseLeave={(e) => {
                  onDropElement(e, index);
                }}
                onTouchStart={(e) => {
                  onStartMoveElement(e, index);
                }}
                onTouchMove={(e) => {
                  onMoveElement(e, index);
                }}
                onTouchEnd={(e) => {
                  onDropElement(e, index);
                }}
                style={{
                  zIndex: passengers.length - index,
                  left: '0px',
                  borderRadius: '7px',
                  // boxShadow: "4px 4px 2px grey"
                }}
              >
                <div className="d-flex flex-column w-100 h-100">
                  <div>
                    <div className="d-flex flex-column w-100  py-4 bg-white border border-radius-xl  ">
                      <div className="d-flex">
                        <div className="d-flex flex-column col-6 p-0 ">
                          <div className="d-flex justify-content-center align-items-center w-100  text-center text-primary">
                            <FormattedMessage id="booking.passengername" />
                          </div>
                          <div className="d-flex justify-content-center align-items-center pt-1 w-100  text-center text-secondary">
                            {item.firstName}
                          </div>
                        </div>
                        <div className="d-flex flex-column col-6 p-0 font-weight-bold text-center  ">
                          <div className="d-flex justify-content-center align-items-center  w-100   text-primary text-center">
                            <FormattedMessage id="booking.lastname" />
                          </div>
                          <div className="d-flex justify-content-center align-items-center pt-1  w-100  text-center text-secondary">
                            {item.lastName}
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-center align-items-center w-100 position-relative ">
                        <QRcode
                          imgBg={true}
                          url={`print-flight-ticket?print=1&id=${id}`}
                          value={`https://${hostName}/#/booking/print-flight-ticket?print=1&id=${id}`}
                          imgSrc={AgencyLogo}
                          renderAs="canvas"
                          size={75}
                          errorCorrectionLevel="H"
                          imgWidth={15}
                          imgHeight={15}
                        />
                      </div>

                      <div className="d-flex">
                        <div className="d-flex flex-column justify-content-center  col-6 p-0 ">
                          <span className="d-flex justify-content-center w-100 text-primary">
                            <FormattedMessage id="booking.ticketno" />
                          </span>
                          <div className="d-flex  justify-content-center text-secondary">
                            {currentTicket && currentTicket.ticketNumber
                              ? currentTicket.ticketNumber
                              : '--'}
                          </div>
                        </div>
                        <div className="d-flex flex-column justify-content-center col-6 p-0 ">
                          <span className="d-flex justify-content-center w-100 text-primary">
                            <FormattedMessage id="booking.referencenumber" />
                          </span>
                          <div className="d-flex justify-content-center text-secondary">
                            {currentTicket && currentTicket.pnr
                              ? currentTicket.pnr
                              : '--'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="d-flex w-100 justify-content-center mt-3">
          {passengers.length > 1 &&
            passengers.map((_, index) => (
              <span
                key={index}
                onClick={() => {
                  index != slideIndex &&
                    setAnimation(
                      direction === 'ltr'
                        ? index > slideIndex
                          ? 'goToRight'
                          : 'goToLeft'
                        : index > slideIndex
                        ? 'goToLeft'
                        : 'goToRight',
                      index,
                    );
                }}
                className={`dot ${slideIndex === index ? 'bg-dark' : ''}`}
              />
            ))}
        </div>
      </div>
    </Fragment>
  );
};
function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}
export default injectIntl(connect(mapStateToProps, {})(PassengerInfo));
